var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBonus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Component 734 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 9051",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 27934"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18185"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8502",
    d: "m449.884 580.277.013.007h.05a.93.93 0 0 0-.063-.007z",
    transform: "translate(-435.267 -571.816)",
    style: {
      fillRule: "evenodd",
      fill: "#8c8d99"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8503",
    d: "M455.629 578.784h-.86a3.759 3.759 0 0 1-2.944 1.577h3.8a1.373 1.373 0 0 1 1.423 1.314v2.1a.275.275 0 0 1-.285.263h-7.116v-3.663h-1.708v3.663h-7.116a.274.274 0 0 1-.285-.263v-2.1a1.373 1.373 0 0 1 1.423-1.314h3.8a3.758 3.758 0 0 1-2.944-1.577h-.86a3.019 3.019 0 0 0-3.131 2.892v2.1a1.872 1.872 0 0 0 1.458 1.774 21.492 21.492 0 0 0 .285 5.755 2.715 2.715 0 0 0 2.448 2.133l1.042.108a46.18 46.18 0 0 0 9.46 0l1.041-.108a2.715 2.715 0 0 0 2.449-2.133 21.538 21.538 0 0 0 .283-5.755 1.871 1.871 0 0 0 1.458-1.774v-2.1a3.019 3.019 0 0 0-3.121-2.892zm-7.685 13.421q-1.846-.035-3.687-.225l-1.041-.107a1.06 1.06 0 0 1-.955-.832 20.054 20.054 0 0 1-.26-5.423h5.942zm7.39-1.164a1.06 1.06 0 0 1-.954.832l-1.042.107q-1.838.189-3.687.225v-6.586h5.942a20.052 20.052 0 0 1-.259 5.422z",
    transform: "translate(-436.804 -571.816)",
    style: {
      fillRule: "evenodd",
      fill: "#8c8d99"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8504",
    d: "M451.818 573.769a4.2 4.2 0 0 0-3.026 1.237 4.193 4.193 0 0 0-3.026-1.237 3.422 3.422 0 1 0 0 6.764h2.118v13.252l.962.015.853-.015v-13.252h1.926l-.051-.024c.082 0 .16.024.243.024a3.422 3.422 0 1 0 0-6.764zm-3.937 3.446a1.842 1.842 0 1 1 0-.128c0 .022-.007.041-.007.063s.007.044.007.066zm3.937 1.757a2 2 0 0 1-2.116-1.757c0-.022.007-.043.007-.064s-.007-.041-.007-.063a2.14 2.14 0 1 1 2.116 1.885z",
    transform: "translate(-436.804 -571.816)",
    style: {
      fill: "#1bc47d",
      fillRule: "evenodd"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBonus);
export default __webpack_public_path__ + "static/media/bonus.eb610bda11e6ba079ea16854237c4c35.svg";
export { ForwardRef as ReactComponent };